// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/loma-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/StyleScript-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/DancingScript-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/AlexBrush-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
}

.card-container:hover {
  background-color: #f6f6f7;
}

.management-datagrid-title {
  font-weight: bold !important;
  font-size: 18px;
  background-color: #f6f6f7;
}

.management-datagrid-registration {
  background-color: #f6f6f7;
}

.management-datagrid-discount {
  font-weight: bold !important;
  white-space: normal !important; /* Allows text to wrap */
  word-break: break-word !important; /* Ensures long words break if needed */
  overflow-wrap: break-word !important; /* Alternative for better wrapping */
  text-align: left; /* Keeps the title aligned */
  background-color: #f6f6f7;
  padding: 5px; /* Adds some spacing */
  min-height: 5.2rem;
}

.custom-cell {
  cursor: pointer; /* Change cursor to pointer on cell hover */
  border: 1px solid transparent; /* Default cell border */
  padding: 6px; /* Add padding to the cell */
  transition: border-color 0.3s ease-in-out; /* Add smooth transition for border */
}

.cell {
  cursor: pointer; /* Change cursor to pointer on cell hover */
}

.apexcharts-xaxis-labels text {
  transform: rotate(-45deg);
  transform-origin: left center;
}

@font-face {
  font-family: "LomaBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "StyleScript";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "DancingScript";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "AlexBrush";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* styles.css */
.scroll-left-animation {
  color: #800000;
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
  animation: scrollLeft 50s linear infinite; /* Default duration */
}

.loaded-list-item {
  background-color: #e3f2fd !important; /* MUI primary color */
  color: #004976 !important;
  /* Smaller font size for list items */
}

.selected-list-item {
  background-color: #004976 !important; /* MUI primary color */
  color: white !important;
  /* Smaller font size for list items */
}

.selected-list-item:hover {
  background-color: #1565c0 !important; /* Slightly darker on hover */
}

.selected-list-item .MuiListItemText-primary {
  font-weight: bold !important;
  font-size: 15px !important;
}

.unselected-list-item {
  background-color: transparent !important;
  color: #004976 !important; /* MUI primary color */
}

.unselected-list-item:hover {
  background-color: #f5faff !important; /* Light blue hover */
}

@media (max-width: 600px) {
  .scroll-left-animation {
    font-size: 14px; /* Smaller font size for mobile screens */
  }
}

.scroll-wrapper {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}

/* Target the input field */
.MuiInputBase-input[type="number"]::-webkit-inner-spin-button,
.MuiInputBase-input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@keyframes scrollLeft {
  0% {
    transform: translateX(100%); /* Start from the right edge */
  }
  100% {
    transform: translateX(-100%); /* Scroll completely to the left */
  }
}

/* FUN FACTS */
@keyframes fun-fact-slide-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme/global.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B,EAAE,wBAAwB;EACxD,iCAAiC,EAAE,uCAAuC;EAC1E,oCAAoC,EAAE,oCAAoC;EAC1E,gBAAgB,EAAE,4BAA4B;EAC9C,yBAAyB;EACzB,YAAY,EAAE,sBAAsB;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,2CAA2C;EAC5D,6BAA6B,EAAE,wBAAwB;EACvD,YAAY,EAAE,4BAA4B;EAC1C,yCAAyC,EAAE,qCAAqC;AAClF;;AAEA;EACE,eAAe,EAAE,2CAA2C;AAC9D;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+DAAyE;EACzE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yCAAyC,EAAE,qBAAqB;AAClE;;AAEA;EACE,oCAAoC,EAAE,sBAAsB;EAC5D,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC,EAAE,sBAAsB;EAC5D,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC,EAAE,6BAA6B;AACrE;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA;EACE;IACE,eAAe,EAAE,yCAAyC;EAC5D;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE;IACE,2BAA2B,EAAE,8BAA8B;EAC7D;EACA;IACE,4BAA4B,EAAE,kCAAkC;EAClE;AACF;;AAEA,cAAc;AACd;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["html,\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.card-container:hover {\r\n  background-color: #f6f6f7;\r\n}\r\n\r\n.management-datagrid-title {\r\n  font-weight: bold !important;\r\n  font-size: 18px;\r\n  background-color: #f6f6f7;\r\n}\r\n\r\n.management-datagrid-registration {\r\n  background-color: #f6f6f7;\r\n}\r\n\r\n.management-datagrid-discount {\r\n  font-weight: bold !important;\r\n  white-space: normal !important; /* Allows text to wrap */\r\n  word-break: break-word !important; /* Ensures long words break if needed */\r\n  overflow-wrap: break-word !important; /* Alternative for better wrapping */\r\n  text-align: left; /* Keeps the title aligned */\r\n  background-color: #f6f6f7;\r\n  padding: 5px; /* Adds some spacing */\r\n  min-height: 5.2rem;\r\n}\r\n\r\n.custom-cell {\r\n  cursor: pointer; /* Change cursor to pointer on cell hover */\r\n  border: 1px solid transparent; /* Default cell border */\r\n  padding: 6px; /* Add padding to the cell */\r\n  transition: border-color 0.3s ease-in-out; /* Add smooth transition for border */\r\n}\r\n\r\n.cell {\r\n  cursor: pointer; /* Change cursor to pointer on cell hover */\r\n}\r\n\r\n.apexcharts-xaxis-labels text {\r\n  transform: rotate(-45deg);\r\n  transform-origin: left center;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"LomaBold\";\r\n  src: url(\"../../public/fonts/loma-bold.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"StyleScript\";\r\n  src: url(\"../../public/fonts/StyleScript-Regular.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"DancingScript\";\r\n  src: url(\"../../public/fonts/DancingScript-VariableFont_wght.ttf\")\r\n    format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"AlexBrush\";\r\n  src: url(\"../../public/fonts/AlexBrush-Regular.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n/* styles.css */\r\n.scroll-left-animation {\r\n  color: #800000;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  display: inline-block;\r\n  animation: scrollLeft 50s linear infinite; /* Default duration */\r\n}\r\n\r\n.loaded-list-item {\r\n  background-color: #e3f2fd !important; /* MUI primary color */\r\n  color: #004976 !important;\r\n  /* Smaller font size for list items */\r\n}\r\n\r\n.selected-list-item {\r\n  background-color: #004976 !important; /* MUI primary color */\r\n  color: white !important;\r\n  /* Smaller font size for list items */\r\n}\r\n\r\n.selected-list-item:hover {\r\n  background-color: #1565c0 !important; /* Slightly darker on hover */\r\n}\r\n\r\n.selected-list-item .MuiListItemText-primary {\r\n  font-weight: bold !important;\r\n  font-size: 15px !important;\r\n}\r\n\r\n.unselected-list-item {\r\n  background-color: transparent !important;\r\n  color: #004976 !important; /* MUI primary color */\r\n}\r\n\r\n.unselected-list-item:hover {\r\n  background-color: #f5faff !important; /* Light blue hover */\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .scroll-left-animation {\r\n    font-size: 14px; /* Smaller font size for mobile screens */\r\n  }\r\n}\r\n\r\n.scroll-wrapper {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Target the input field */\r\n.MuiInputBase-input[type=\"number\"]::-webkit-inner-spin-button,\r\n.MuiInputBase-input[type=\"number\"]::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n@keyframes scrollLeft {\r\n  0% {\r\n    transform: translateX(100%); /* Start from the right edge */\r\n  }\r\n  100% {\r\n    transform: translateX(-100%); /* Scroll completely to the left */\r\n  }\r\n}\r\n\r\n/* FUN FACTS */\r\n@keyframes fun-fact-slide-in {\r\n  from {\r\n    transform: translateX(100%);\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
